import React from 'react';
import { Box, Grid, Skeleton, Paper } from '@mui/material';

function MonthlyLoadingSkeleton() {
    return (
        <Box sx={{ width: '100%' }}>
            {/* KPI Cards Skeletons */}
            <Grid container spacing={2.5} sx={{ mb: 3 }}>
                {[1, 2, 3, 4].map((item) => (
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item}>
                        <Paper sx={{ p: 2.5, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Skeleton variant="text" width="40%" height={20} />
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                            <Skeleton variant="text" width="60%" height={48} />
                            <Skeleton variant="text" width="80%" height={20} sx={{ mt: 1 }} />
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {/* Chart Skeleton */}
            <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Skeleton variant="text" width="30%" height={32} />
                    <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="rectangular" width="100%" height={350} sx={{ borderRadius: 1 }} />
            </Paper>

            {/* Table Skeleton */}
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Skeleton variant="text" width="25%" height={32} sx={{ mb: 2 }} />
                {[1, 2, 3, 4, 5].map((item) => (
                    <Skeleton key={item} variant="rectangular" width="100%" height={40} sx={{ mb: 1, borderRadius: 1 }} />
                ))}
            </Paper>
        </Box>
    );
}

export default MonthlyLoadingSkeleton;
